import { ForwardedRef, forwardRef, TextareaHTMLAttributes } from 'react'

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: 'primary' | 'secondary' | 'third' | 'danger'
  placeholder?: string
  helperText?: string
}

export const TextArea = forwardRef(
  (
    {
      variant = 'primary',
      className,
      placeholder,
      helperText,
      ...rest
    }: TextAreaProps,
    ref: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const variantClasses = {
      primary:
        'shadow-md w-full order-blue-500 focus:border-blue-600 mb-5 placeholder-black',
      secondary: 'border-gray-300 focus:border-gray-400 placeholder-black',
      third:
        'shadow-md w-full order-blue-500 focus:border-blue-600 mb-2 placeholder-[#c1c1c1]',
      danger:
        'shadow-md bg-red-50 border border-red-500 text-red-900 ' +
        'placeholder-red-700 text-sm rounded-lg focus:ring-red-500 ' +
        'focus:border-red-500 block w-full p-2.5',
    }

    return (
      <div className="relative">
        <textarea
          ref={ref}
          placeholder={placeholder}
          rows={4}
          className={`rounded-md border px-4 py-2  
          focus:outline-none focus:ring-2 focus:ring-${variant}-500 ${variantClasses[variant]} ${className}`}
          {...rest}
        />
        <p className="mt-2 text-sm text-red-600">{helperText}</p>
      </div>
    )
  },
)
